const Errorss = () =>{
    return (<>Error</>)
}

export default Errorss;